/**
 * @generated SignedSource<<eb3553987a77d703fb8bd160b315e189>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SlackProductConnectionSlackChannelType = "private" | "public" | "%future added value";
export type EditSlackProductConnectionInput = {
  channelId?: string | null;
  inviteURL?: string | null;
  slackProductConnectionId: string;
};
export type SlackProductConnectionSettingsModal_editMutation$variables = {
  input: EditSlackProductConnectionInput;
};
export type SlackProductConnectionSettingsModal_editMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly channel: {
        readonly id: string;
        readonly name: string;
        readonly type: SlackProductConnectionSlackChannelType;
      } | null;
      readonly inviteURL: string | null;
    } | null;
  };
};
export type SlackProductConnectionSettingsModal_editMutation = {
  response: SlackProductConnectionSettingsModal_editMutation$data;
  variables: SlackProductConnectionSettingsModal_editMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inviteURL",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SlackChannel",
  "kind": "LinkedField",
  "name": "channel",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackProductConnectionSettingsModal_editMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditSlackProductConnectionResponse",
        "kind": "LinkedField",
        "name": "editSlackProductConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlackProductConnection",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackProductConnectionSettingsModal_editMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditSlackProductConnectionResponse",
        "kind": "LinkedField",
        "name": "editSlackProductConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlackProductConnection",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0998770f8191aa3145663688960b457",
    "id": null,
    "metadata": {},
    "name": "SlackProductConnectionSettingsModal_editMutation",
    "operationKind": "mutation",
    "text": "mutation SlackProductConnectionSettingsModal_editMutation(\n  $input: EditSlackProductConnectionInput!\n) {\n  response: editSlackProductConnection(input: $input) {\n    node {\n      inviteURL\n      channel {\n        id\n        name\n        type\n      }\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1188fbb2c8d089abdc66ad352ad5cc2d";

export default node;
